import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { createDataTestId } from '../lib/formatters';
import './FlatTab.scss';
import { Indicator } from '@mantine/core';
import sparkleImage from '../../../images/Sparkle.svg';

class FlatTab extends Component {
  static propTypes = {
    tabIndex: PropTypes.number,
    title: PropTypes.string,
    tabClick: PropTypes.func,
    selected: PropTypes.bool,
    className: PropTypes.string,
    selectedClassName: PropTypes.string,
    isDisabled: PropTypes.bool,
    showIndicator: PropTypes.func,
    indicatorText: PropTypes.string,
    showImage: PropTypes.bool
  };

  constructor(props) {
    super(props);
    this.handleTabClick = this.handleTabClick.bind(this);
    this.getClickHandler = this.getClickHandler.bind(this);
  }

  handleTabClick(e) {
    this.props.tabClick.apply(this, e);
  }

  getClickHandler(e) {
    if (!this.props.isDisabled) {
      e.stopPropagation();
      e.nativeEvent.stopImmediatePropagation();
      this.props.tabClick(this, e);
    }
  }

  render() {
    const { className, selected, selectedClassName, tabIndex, title, showIndicator = () => undefined, indicatorText = 'New', showImage = false } = this.props;

    const titleClass = classNames({
      'flat__tab--title': true,
      [`${selectedClassName}`]: selected && selectedClassName
    });

    return (
      <div
        className={`flat__tab ${className}`}
        data-test-id={createDataTestId(title, 'tab')}
        onClick={this.props.tabClick ? this.getClickHandler : null}
      >
        {showImage && (
          <img
            src={sparkleImage}
            alt="Tab Icon"
            className="tab-icon"
            style={{ width: '18px', height: '18px', marginRight: '8px' }}
          />
        )}

        {showIndicator(tabIndex) ? (
          <Indicator inline label={indicatorText} size={18}>
            <span className={titleClass}>{title}</span>
          </Indicator>
        ) : (
          <span className={titleClass}>{title}</span>
        )}
      </div>
    );
  }
}

export default FlatTab;